/**
 * Japonya (TSE) hisse verisi.
 *
 * Eskiden var olmayan /api/jp uçlarına gidiyordu; artık backend'in gerçek piyasa
 * uçlarını kullanan ortak adaptör üzerinden çalışır. Dışa açık tipler ve fonksiyon
 * imzaları AsiaStockDetailClient'ın sözleşmesini korur.
 */
import { fetchAsiaQuotes, fetchChartSeries, fetchPeriodChanges } from '@/services/marketAdapter'
import type { AsiaQuote, ChartPoint, PeriodChange } from '@/services/marketAdapter'

export type { AsiaQuote, ChartPoint, PeriodChange }

export const fetchJpQuotes = (symbols: string[]): Promise<Record<string, AsiaQuote>> =>
  fetchAsiaQuotes(symbols)

export const fetchJpChartData = (symbol: string, period: string): Promise<ChartPoint[]> =>
  fetchChartSeries(symbol, period)

export const fetchJpPeriodChanges = (symbols: string[]): Promise<Record<string, PeriodChange>> =>
  fetchPeriodChanges(symbols)
